module.exports = __webpack_public_path__ + "static/media/diameter1.fc162b2f.jpg";